import AdminLayout from '@/layouts/AdminLayout.vue'

/** Always-available public / auth routes */
export const constantRoutes = [
  {
    path: '/welcome',
    name: 'welcome',
    component: () => import('@/views/login/Welcome.vue'),
    meta: { public: true }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/LoginThree.vue'),
    meta: { public: true }
  },
  {
    path: '/redirect',
    name: 'redirect',
    component: () => import('@/views/login/LoginThree.vue'),
    meta: { public: true }
  },
  {
    path: '/oidc-callback',
    name: 'oidcCallback',
    component: () => import('@/views/login/OidcCallback.vue'),
    meta: { public: true }
  },
  {
    path: '/loginAuto',
    name: 'loginAuto',
    component: () => import('@/views/login/LoginAuto.vue'),
    meta: { public: true }
  },
  {
    path: '/clientAutoLogin',
    name: 'clientAutoLogin',
    component: () => import('@/views/login/ClientAutoLogin.vue'),
    meta: { public: true }
  },
  {
    path: '/forgetPassword',
    name: 'forgetPassword',
    component: () => import('@/views/login/ForgetPassword.vue'),
    meta: { public: true }
  },
  {
    path: '/retrieveEmail',
    name: 'retrieveEmail',
    component: () => import('@/views/login/RetrieveEmail.vue'),
    meta: { public: true }
  },
  {
    path: '/tutorClient',
    name: 'tutorClient',
    component: () => import('@/views/login/TutorClient.vue'),
    meta: { public: true }
  },
  {
    path: '/test',
    name: 'agora-test',
    component: () => import('@/views/test/index.vue'),
    meta: { title: 'AClassroom' }
  },
  {
    path: '/500',
    name: 'serverError',
    component: () => import('@/views/error/ServerError.vue'),
    meta: { public: true }
  },
  {
    path: '/404',
    name: 'notFoundPage',
    component: () => import('@/views/error/NotFound.vue'),
    meta: { public: true }
  }
]

/**
 * Post-login shell routes (Phase 1: home + growth placeholder).
 * More business routes register in later phases via permission store.
 */
export const asyncRoutes = [
  {
    path: "/",
    name: "admin",
    component: AdminLayout,
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("@/views/dashboard/index.vue"),
        meta: { title: "Dashboard" },
      },
      {
        path: "conversionRanking",
        name: "conversionRanking",
        component: () => import("@/views/rankData/ConversionRanking.vue"),
        meta: { title: "Trial Class Ranking Board" },
      },
      {
        path: "receivedOrdersRanking",
        name: "receivedOrdersRanking",
        component: () => import("@/views/rankData/ReceivedOrdersRanking.vue"),
        meta: { title: "Received Orders Ranking Board" },
      },
      {
        path: "10sResponseRateRanking",
        name: "10sResponseRateRanking",
        component: () => import("@/views/rankData/ResponseRateRanking.vue"),
        meta: { title: "10s Response Rate Ranking Board" },
      },
      {
        path: "emotionalMotivationRanking",
        name: "emotionalMotivationRanking",
        component: () => import("@/views/rankData/EmotionalMotivationRanking.vue"),
        meta: { title: "Emotional Motivation Ranking" },
      },
      {
        path: "ebList",
        name: "ebList",
        component: () => import("@/views/rankData/EBList.vue"),
        meta: { title: "EB Details" },
      },
      {
        path: "classTab",
        name: "classTab",
        component: () => import("@/views/classTab/index.vue"),
        meta: { title: "Class Table" },
      },
      {
        path: "releaseTime/submit",
        name: "releaseTime",
        component: () => import("@/views/classTab/ReleaseTime.vue"),
        meta: { title: "Class Time Setting" },
      },
      {
        path: "releaseTime/cancle",
        name: "autonomousCancellation",
        component: () => import("@/views/classTab/AutonomousCancellation.vue"),
        meta: { title: "Autonomous Cancellation" },
      },
      {
        path: "classDetail/:id",
        name: "classDetail",
        component: () => import("@/views/classDetail/index.vue"),
        meta: { title: "Class Detail" },
      },
      {
        path: "trainingCenter",
        name: "trainingCenter",
        component: () => import("@/views/trainingCenter/index.vue"),
        redirect: "/trainingCenter/trainingOverview",
        meta: { title: "Training Center" },
        children: [
          {
            path: "trainingOverview",
            name: "trainingOverview",
            component: () => import("@/views/trainingCenter/TrainingOverview.vue"),
            meta: { title: "Training Overview" },
          },
          {
            path: "mySubscription",
            name: "mySubscription",
            component: () => import("@/views/trainingCenter/MySubscription.vue"),
            meta: { title: "My Subscription" },
          },
          {
            path: "selfstudyCourses",
            name: "selfstudyCourses",
            component: () => import("@/views/trainingCenter/SelfstudyCourses.vue"),
            meta: { title: "Self-study Courses" },
          },
          {
            path: "onlineTraining",
            name: "onlineTraining",
            component: () => import("@/views/trainingCenter/OnlineTraining.vue"),
            meta: { title: "Training Consultations" },
          },
          {
            path: "moodleMessage",
            name: "moodleMessage",
            component: () => import("@/views/trainingCenter/MoodleMessage.vue"),
            meta: { title: "Moodle Messages" },
          },
        ],
      },
      {
        path: "trainingCenter/courseDetail/:id",
        name: "courseDetail",
        component: () => import("@/views/trainingCenter/CourseDetail.vue"),
        meta: { title: "Course Detail" },
      },
      {
        path: "trainingKit",
        name: "trainingKit",
        component: () => import("@/views/trainingKit/index.vue"),
        meta: { title: "Training Kit" },
      },
      {
        path: "trainingkitDetails/:id",
        name: "trainingkitDetails",
        component: () => import("@/views/trainingkitDetails/index.vue"),
        meta: { title: "Training Kit Details" },
      },
      {
        path: "trainingResources/:id",
        name: "trainingResources",
        component: () => import("@/views/trainingkitDetails/TrainingResources.vue"),
        meta: { title: "Training Resources" },
      },
      {
        path: "resourcesFolder",
        name: "resourcesFolder",
        component: () => import("@/views/trainingkitDetails/ResourcesFolder.vue"),
        meta: { title: "Resources Folder" },
      },
      {
        path: "trainingTestDetails",
        name: "trainingTestDetails",
        component: () => import("@/views/trainingkitDetails/TrainingTestDetails.vue"),
        meta: { title: "Training Test" },
      },
      {
        path: "trainingTestAnswer",
        name: "trainingTestAnswer",
        component: () => import("@/views/trainingkitDetails/TrainingTestAnswer.vue"),
        meta: { title: "Training Test Answer" },
      },
      {
        path: "serviceFee",
        name: "serviceFee",
        component: () => import("@/views/serviceFee/index.vue"),
        redirect: "/serviceFee/accounting",
        meta: { title: "Service Fee" },
        children: [
          {
            path: "accounting",
            name: "accounting",
            component: () => import("@/views/serviceFee/Accounting.vue"),
            meta: { title: "Accounting" },
          },
          {
            path: "paymentRecord",
            name: "paymentRecord",
            component: () => import("@/views/serviceFee/PaymentRecord.vue"),
            meta: { title: "Payment Record" },
          },
          {
            path: "historyRemarks",
            name: "historyRemarks",
            component: () => import("@/views/serviceFee/HistoryRemarks.vue"),
            meta: { title: "History Remarks" },
          },
          {
            path: "completedClasses",
            name: "completedClasses",
            component: () => import("@/views/serviceFee/CompletedClasses.vue"),
            meta: { title: "Completed Classes" },
          },
        ],
      },
      {
        path: "message",
        name: "message",
        component: () => import("@/views/message/index.vue"),
        redirect: "/message/notice",
        meta: { title: "Message" },
        children: [
          {
            path: "notice",
            name: "notice",
            component: () => import("@/views/message/Notice.vue"),
            meta: { title: "Notice" },
          },
          {
            path: "warning",
            name: "warning",
            component: () => import("@/views/message/Warning.vue"),
            meta: { title: "Warning" },
          },
          {
            path: "remind",
            name: "remind",
            component: () => import("@/views/message/Remind.vue"),
            meta: { title: "Remind" },
          },
        ],
      },
      {
        path: "message/view/:id",
        name: "messageView",
        component: () => import("@/views/message/MessageView.vue"),
        meta: { title: "Message Detail" },
      },
      {
        path: "SOP",
        name: "SOP",
        component: () => import("@/views/SOP/index.vue"),
        redirect: "/SOP/scoreClass",
        meta: { title: "SOP Score/class" },
        children: [
          {
            path: "scoreClass",
            name: "scoreClass",
            component: () => import("@/views/SOP/ScoreClass.vue"),
            meta: { title: "SOP Score/class" },
          },
          {
            path: "assessmentSummary",
            name: "assessmentSummary",
            component: () => import("@/views/SOP/AssessmentSummary.vue"),
            meta: { title: "SOP Assessment Summary" },
          },
        ],
      },
      {
        path: "complaintList",
        name: "complaintList",
        component: () => import("@/views/complaintList/index.vue"),
        redirect: "/complaintList/recitationClassesReport",
        meta: { title: "Assessment" },
        children: [
          {
            path: "qualityFlaggedLessons",
            name: "qualityFlaggedLessons",
            component: () =>
              import("@/views/complaintList/QualityFlaggedLessons.vue"),
            meta: { title: "Quality Flagged Lessons" },
          },
          {
            path: "pronunciationCorrectionPerformanceDashboard",
            name: "pronunciationCorrectionPerformanceDashboard",
            component: () =>
              import("@/views/complaintList/PronunciationDashboard.vue"),
            meta: { title: "Pronunciation Correction Performance Dashboard" },
          },
          {
            path: "liveStreamingProcessManagement",
            name: "liveStreamingProcessManagement",
            component: () =>
              import("@/views/complaintList/LiveStreamingProcess.vue"),
            meta: { title: "Live streaming process management" },
          },
          {
            path: "recitationClassesReport",
            name: "recitationClassesReport",
            component: () => import("@/views/complaintList/ClassroomProcess.vue"),
            meta: { title: "Classroom Process Management" },
          },
          {
            path: "receivedComplaint",
            name: "receivedComplaint",
            component: () => import("@/views/complaintList/ReceivedComplaint.vue"),
            meta: { title: "Received Complaint" },
          },
          {
            path: "lateAttendanceEarlyLeave",
            name: "lateAttendanceEarlyLeave",
            component: () =>
              import("@/views/complaintList/LateAttendanceEarlyLeave.vue"),
            meta: { title: "Late and leave early" },
          },
        ],
      },
      {
        path: "comments",
        name: "comments",
        component: () => import("@/views/comments/index.vue"),
        redirect: "/comments/commentDetails",
        meta: { title: "Student Comment" },
        children: [
          {
            path: "commentDetails",
            name: "commentDetails",
            component: () => import("@/views/comments/CommentDetails.vue"),
            meta: { title: "Comment Details" },
          },
          {
            path: "labelImpression",
            name: "labelImpression",
            component: () => import("@/views/comments/LabelImpression.vue"),
            meta: { title: "Label Impression" },
          },
        ],
      },
      {
        path: "myFeedback",
        name: "myFeedback",
        component: () => import("@/views/myFeedback/index.vue"),
        meta: { title: "Feedback" },
      },
      {
        path: "newPersonalData",
        name: "newPersonalData",
        component: () => import("@/views/personalData/index.vue"),
        meta: { title: "Personal Data" },
      },
      {
        path: "leaveRequest",
        redirect: "/leave/leaveRequest",
      },
      {
        path: "leave",
        name: "leave",
        component: () => import("@/views/leave/index.vue"),
        redirect: "/leave/leaveRequest",
        meta: { title: "Leave" },
        children: [
          {
            path: "leaveRequest",
            name: "leaveRequest",
            component: () => import("@/views/leave/LeaveRequest.vue"),
            meta: { title: "Leave Request" },
          },
          {
            path: "leaveRecord",
            name: "leaveRecord",
            component: () => import("@/views/leave/LeaveRecord.vue"),
            meta: { title: "Leave List" },
          },
        ],
      },
      {
        path: "flowers",
        name: "flowers",
        component: () => import("@/views/flowers/index.vue"),
        redirect: "/flowers/usedFlowers",
        meta: { title: "Flowers" },
        children: [
          {
            path: "usedFlowers",
            name: "usedFlowers",
            component: () => import("@/views/flowers/UsedFlowers.vue"),
            meta: { title: "Used Flowers" },
          },
          {
            path: "obtainedFlowers",
            name: "obtainedFlowers",
            component: () => import("@/views/flowers/ObtainedFlowers.vue"),
            meta: { title: "Obtained Flowers" },
          },
        ],
      },
      {
        path: "publicClass",
        name: "publicClass",
        component: () => import("@/views/publicClass/index.vue"),
        meta: { title: "Public Class" },
      },
      {
        path: "referrals",
        name: "referrals",
        component: () => import("@/views/referrals/index.vue"),
        meta: { title: "My Referrals" },
      },
      {
        path: "referralsList",
        name: "referralsList",
        component: () => import("@/views/referrals/ReferralsList.vue"),
        meta: { title: "Referral Records" },
      },
      {
        path: "referralStatus",
        name: "referralStatus",
        component: () => import("@/views/referrals/ReferralStatus.vue"),
        meta: { title: "Referral Policy" },
      },
      {
        path: "signContract",
        name: "signContract",
        component: () => import("@/views/signContract/index.vue"),
        meta: { title: "Sign Contract" },
      },
      {
        path: "signContract/contract",
        name: "contractPreview",
        component: () => import("@/views/signContract/ContractPreview.vue"),
        meta: { title: "Contract Preview" },
      },
      {
        path: "signContractCustom",
        name: "signContractCustom",
        component: () => import("@/views/signContractCustom/index.vue"),
        meta: { title: "Sign Contract" },
      },
      {
        path: "signContractCustom/contractCustom",
        name: "contractCustomPreview",
        component: () =>
          import("@/views/signContractCustom/ContractPreview.vue"),
        meta: { title: "Contract Preview" },
      },
      {
        path: "signContractEditor",
        name: "signContractEditor",
        component: () => import("@/views/signContractEditor/index.vue"),
        meta: { title: "Sign Contract" },
      },
      {
        path: "signContractEditor/contractEditor",
        name: "contractEditorPreview",
        component: () =>
          import("@/views/signContractEditor/ContractPreview.vue"),
        meta: { title: "Contract Preview" },
      },
      {
        path: "aiChat",
        name: "aiChat",
        component: () => import("@/views/aiChat/index.vue"),
        meta: { title: "AI Chat" },
      },
      {
        path: "teacherTask",
        name: "teacherTask",
        component: () => import("@/views/teacherTask/index.vue"),
        meta: { title: "Teacher Task" },
      },
      {
        path: "teacherTask/myTaskPage",
        name: "teacherTaskMyPage",
        component: () => import("@/views/teacherTask/MyTaskPage.vue"),
        meta: { title: "Received Tasks" },
      },
      // Growth Center (Vue2 /growthCenter + children)
      {
        path: "growthCenter",
        name: "growthCenterIndex",
        component: () => import("@/views/growthCenter/index.vue"),
        redirect: { name: "growthCenter" },
        meta: { title: "Growth Center" },
        children: [
          {
            path: "",
            name: "growthCenter",
            component: () => import("@/views/growthCenter/GrowthCenter.vue"),
            meta: { title: "Growth Center" },
          },
          {
            path: "achievementRewards",
            name: "achievementRewards",
            component: () => import("@/views/growthCenter/AchievementRewards.vue"),
            meta: { title: "Achievement Rewards" },
          },
          {
            path: "strengthAssessment",
            name: "strengthAssessment",
            component: () => import("@/views/growthCenter/StrengthAssessment.vue"),
            meta: { title: "Strength Assessment" },
          },
          {
            path: "myGoal",
            name: "myGoal",
            component: () => import("@/views/growthCenter/MyGoal.vue"),
            meta: { title: "My Goal" },
          },
        ],
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    name: "catchAll",
    component: () => import("@/views/error/NotFound.vue"),
    meta: { public: true },
  },
];
